import { memo } from "react";
import { css } from "styled-components";

import { getViewTransitionAnimationName } from "../../utils/functions";

import SingleViewTransition, { type ViewTransitionItem } from "./SingleViewTransition";

const viewTransitions: ViewTransitionItem[] = [
   {
      name: "add-property-page",
      path: "/add-property",
      css: css`
         @keyframes ${getViewTransitionAnimationName("add-property-page")} {
            from {
               opacity: 0;
               transform: translateY(${16 * 2}px);
            }
            to {
               opacity: 1;
               transform: translateY(0);
            }
         }
      `,
   },
];

function ViewTransitions() {
   return (
      <>
         {viewTransitions.map((item) => (
            <SingleViewTransition item={item} key={item.name} />
         ))}
      </>
   );
}

export default memo(ViewTransitions);
